import React from 'react';
import 'App.scss';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import { createStore, compose, applyMiddleware } from '@reduxjs/toolkit';
import reducer from 'reducers';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { push as Menu } from 'react-burger-menu'

import Footer from 'components/Footer';
import AboutUsView from 'views/AboutUs';
import AreaStandardsView from 'views/AreaStandards';
import ContractorsView from 'views/Contractors';
import HomeView from 'views/Home';
import PoliticalCornerView from 'views/PoliticalCorner';
import TrainingView from 'views/Training';
import WorkerAbuseView from 'views/WorkerAbuse';
import Nav from 'components/nav';
import PayDues from 'views/PayDues';
import PayDuesOnline from 'views/PayDues/online';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, composeEnhancers(
  applyMiddleware(promiseMiddleware, thunk)
));

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <div>
          <Menu right pageWrapId={ "page-wrap" } outerContainerId={ "root" }>
            <Nav />
          </Menu>
          <div className="app" id="page-wrap">
            <Routes>
              <Route path="/" element={<HomeView />} />
              <Route path="/about" element={<AboutUsView />} />
              <Route path="/area-standards" element={<AreaStandardsView />} />
              <Route path="/contractors" element={<ContractorsView />} />
              <Route path="/politics" element={<PoliticalCornerView />} />
              <Route path="/training" element={<TrainingView />} />
              <Route path="/abuse" element={<WorkerAbuseView />} />
              <Route path="/pay-dues" element={<PayDues />} />
              <Route path="/pay-dues/online" element={<PayDuesOnline />} />
            </Routes>
            <Footer />
          </div>
        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
